import { Navigate } from 'react-router-dom';
import React, { FC, PropsWithChildren } from 'react';
import { useAtomValue } from 'jotai';
import { inboxLoginStatus } from '@/state/inboxAuth';
import routes from '@/components/inbox/routes';

export type AuthenticatedRouteProps = PropsWithChildren;

const AuthenticatedRoute: FC<AuthenticatedRouteProps> = ({ children }) => {
  const loginStatus = useAtomValue(inboxLoginStatus);

  if (loginStatus === 'LOGGED_OUT') {
    return <Navigate to={routes.login.replace(':country?', '')} replace />;
  }

  return <>{children}</>;
};

export default AuthenticatedRoute;
